'use strict';

exports.__esModule = true;
exports.ProfileBadge = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styles = require('../../src/styles/styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProfileBadge = function ProfileBadge(props) {
    var isSmall = props.isSmall,
        isCore = props.isCore,
        isVideoConsultation = props.isVideoConsultation;


    var modifierClass = isCore ? isVideoConsultation ? 'core-and-video-consultation' : 'core' : isVideoConsultation ? 'video-consultation' : undefined;

    if (modifierClass && isSmall) {
        modifierClass = modifierClass + '-small';
    }

    var showContent = isCore;

    return _react2.default.createElement(
        'div',
        { className: [_styles2.default.profileBadge, modifierClass && _styles2.default['profile-badge_' + modifierClass] || '', isSmall && _styles2.default['profile-badge_small'] || ''].join(' ')
        },
        showContent && _react2.default.createElement(
            'div',
            { className: _styles2.default['profile-badge__content'] },
            isCore && _react2.default.createElement(
                'p',
                null,
                'Premier consultants work closely with Vitality to offer you a great service.'
            )
        )
    );
};

ProfileBadge.propTypes = {
    isSmall: require('react').PropTypes.bool,
    isCore: require('react').PropTypes.bool,
    isVideoConsultation: require('react').PropTypes.bool
};
ProfileBadge.displayName = 'ProfileBadge';

exports.ProfileBadge = ProfileBadge;


// WEBPACK FOOTER //
// ./components/profile-badge/lib/components/profile-badge.js